import React, { PureComponent } from 'react'
import { Modal, Col, Button } from 'react-bootstrap'

class FaqModal extends PureComponent {
  constructor () {
    super()
    this.state = {
      positiveIco: 'glyphicon glyphicon-thumbs-up',
      negativeIco: 'glyphicon glyphicon-thumbs-down',
      voted: false
    }
  }

  UNSAFE_componentWillReceiveProps (nextProps) {
    if (nextProps && nextProps.questionId && (!this.props || !this.props.questionId || this.props.questionId !== nextProps.questionId)) {
      this.setState({ positiveIco: 'glyphicon glyphicon-thumbs-up', negativeIco: 'glyphicon glyphicon-thumbs-down', voted: false })
      this.props.actions.fetchQuestion(nextProps.questionId)
    }
  }

  vote (isPositive) {
    if (!this.state.voted) {
      if (isPositive) {
        this.setState({ positiveIco: this.state.positiveIco + ' voted votedUp', negativeIco: this.state.negativeIco + ' voted', voted: true })
      } else {
        this.setState({ negativeIco: this.state.negativeIco + ' voted votedDown', positiveIco: this.state.positiveIco + ' voted', voted: true })
      }
      this.props.actions.voteQuestion(this.props.question.faqId, isPositive)
    }
  }

  render () {
    const {
      t, showModal, question, closeModal
    } = this.props

    const tKey = 'FAQ.MODAL.'
    return (
      <Modal id="faqModal" show={showModal} bsSize="large" className="_nf">
        <Modal.Header closeButton onHide={closeModal} >
          <Modal.Title>
            {question && question.title}
          </Modal.Title>
        </Modal.Header>
        <Modal.Body>
          <div dangerouslySetInnerHTML={{ __html: question && question.description.replace('<br/>', '\n') }} />
        </Modal.Body>
        <Modal.Footer>
          <div className="faq-assessment">
            <p className="faq-assessment-text">
              {t(`${tKey}ASSESSMENT_QUESTION`)}
            </p>
            <a onClick={() => { this.vote(true) }} className="_Btn new stk o-icn"><i className={this.state.positiveIco}/></a>
            <a onClick={() => { this.vote(false) }} className="_Btn cancel stk o-icn"><i className={this.state.negativeIco}/></a>
          </div>
          <Col sm={12} className="flexInLine al-C">
            <Button className="_Btn accept" onClick={() => { closeModal() }}>
              {t(`${tKey}CLOSE_BTN`)}
            </Button>
          </Col>
        </Modal.Footer>
      </Modal>
    )
  }
}

export default FaqModal
